import { FC } from 'react'
import { useMediaQuery, useTheme } from '@mui/material'
import { DefectsList } from 'components/Defects'
import { UserProtectedRoute } from 'routes'

// Index route of /faults. On desktop the list lives in the Helpdesk layout's
// left column and the first ticket is auto-selected; on mobile it renders here.
const FaultsPage: FC = () => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))

  return <UserProtectedRoute>{!isDesktop && <DefectsList />}</UserProtectedRoute>
}

export default FaultsPage
